import { useEffect } from "react";
import { useSocket } from "../contexts/SocketContext";
import { notify } from "../utils/toast";
import { useQueryClient } from "@tanstack/react-query";
import { warehouseQueryKey } from "../query/QueryKey";

function NotificationListener() {
  const { socket } = useSocket();
  const qc = useQueryClient();
  useEffect(() => {
    if (!socket) return;
    const audio = new Audio("/shopee.mp3");
    const handler = (data: {
      message: string;
      title: string;
      type?: string;
    }) => {
      qc.invalidateQueries({
        queryKey: [warehouseQueryKey.NOTIFICATIONS],
        exact: false,
      });
      audio.currentTime = 0;
      audio.play().catch((err) => {
        console.warn("Autoplay blocked, chờ user interaction:", err);
      });
      switch (data.type) {
        case "success":
          notify.success(data.title, data.message);
          break;
        case "error":
          notify.error(data.title, data.message);
          break;
        case "warning":
          notify.warning(data.title, data.message);
          break;
        default:
          notify.info(data.title, data.message);
      }
    };
    socket.on("notification", handler);
    return () => {
      socket.off("notification", handler);
    };
  }, [socket, qc]);
  return null;
}
export default NotificationListener;
